// extracted by mini-css-extract-plugin
export var adjacentSlide = "_s7-9";
export var arrowButtonContainer = "_s7-5";
export var arrowButtonIcon = "_s7-6";
export var carouselArrowButton = "_s7-2";
export var carouselElementContainer = "_s7-1";
export var currentSlide = "_s7-8";
export var left = "_s7-3";
export var otherSlide = "_s7-a";
export var productCarouselContainer = "_s7-0";
export var right = "_s7-4";
export var sliderOverflow = "_s7-7";